(() => {
    const
        interval = 500,
        productFruitsSelector = ".productfruits--container",
        troublesomeElementsSelector = ".accordion-header, .dropdown-toggle";

    window.setInterval(() => {
        if (!document.querySelector(productFruitsSelector)) {
            return;
        }
        if (!document.querySelector(troublesomeElementsSelector)) {
            return;
        }
        window.dispatchEvent(new Event("resize"));
    }, interval);
})();
